import React from 'react'
import styled from '@emotion/styled'
import { Banner } from 'src/components/molecules/Banner'

export const TopBanner = () => {
  return (
    <TopBannerView
      text="【新プロダクト】 カスタマーサクセスのアクションを最速で効率化！顧客状況把握・一括アクションが可能なSuccessHubはこちらから。"
      link="https://www.successhub.jp/?utm_source=service-site&utm_medium=referral&utm_campaign=SH_lp_view&utm_content=header"
    />
  )
}

const TopBannerView = styled(Banner)`
  padding: 0 20px;
  box-sizing: border-box;
`
